import { AxiosPromise } from 'axios';

import { vaultApi } from '../api';
import { IApiResponse } from '../interfaces';
import { ISecurityProfile } from './interfaces';

const basePath = '/securityProfiles';

/* eslint-disable implicit-arrow-linebreak */

export const getSecurityProfiles = (): AxiosPromise<IApiResponse<Array<ISecurityProfile>>> =>
  vaultApi.getInstance().get(basePath);

export const updateSecurityProfile = (id: string, profile: any): AxiosPromise<IApiResponse<any>> =>
  vaultApi.getInstance().put(`${basePath}/${id}`, profile);
